import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import PricesScreen from "./PricesScreen";
import SettingsScreen from "./SettingsScreen";


class App extends React.Component {
    render() {
        return (
            <Router>
                <div>
                    <Switch>
                        <Route exact path="/">
                            <PricesScreen/>
                        </Route>
                        <Route exact path="/ayarlar">
                            <SettingsScreen/>
                        </Route>
                    </Switch>
                </div>
            </Router>
        )
    }
}

export default App


// WEBPACK FOOTER //
// ./src/App.js